"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ExclamationMark.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ExclamationMark = function ExclamationMark(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 189.9 189.9"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Exclamation Mark"), _react2.default.createElement("path", {
    className: "exclamation-mark",
    d: "M94.95 0a94.95 94.95 0 1 0 94.95 95A95 95 0 0 0 94.95 0zm-9.27 34.86h19.1v47.08a143.75 143.75 0 0 1-.74 14.69q-.74 7.2-1.89 15.27H88.28q-1.15-8.07-1.89-15.27a143.47 143.47 0 0 1-.71-14.69V34.86zm20.8 112.73a12.23 12.23 0 0 1-2.68 3.91 12.39 12.39 0 0 1-4 2.59 12.69 12.69 0 0 1-4.86.95 12.89 12.89 0 0 1-4.94-.95 12.35 12.35 0 0 1-4-2.59 11.66 11.66 0 0 1-2.63-3.91 13 13 0 0 1 0-9.75 11.61 11.61 0 0 1 2.63-4 13 13 0 0 1 4-2.63 12.41 12.41 0 0 1 4.94-1 12.22 12.22 0 0 1 4.86 1 13 13 0 0 1 4 2.63 12.49 12.49 0 0 1 2.68 13.75z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = ExclamationMark;